export const productConstants = {
  PRODUCT_REQUEST: 'PRODUCT_REQUEST',
  PRODUCT_SUCCESS: 'PRODUCT_SUCCESS',
  PRODUCT_FAILURE: 'PRODUCT_FAILURE',

  PRODUCT_HIRING_REQUEST: 'PRODUCT_HIRING_REQUEST',
  PRODUCT_HIRING_SUCCESS: 'PRODUCT_HIRING_SUCCESS',
  PRODUCT_HIRING_FAILURE: 'PRODUCT_HIRING_FAILURE',
}
